<div
  [ngClass]="fieldClassesString"
  [attr.id]="id"
  >
  <label
    [attr.for]="id"
    soho-label
    [required]="required$ | async"
    lm-label
    [layoutField] = "field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
  @if (displayAsText) {
    <div
      lm-field-options
      [hasContextMenu]="insertContextMenu"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      [disableFieldOptions]="disableFieldOptions"
      [fieldAutomationId]="fieldAutomationId"
      (contextmenu)="onContextMenu($event)"
      class="lm-radio-field-options"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      >
      <p class="lm-text-data hide-white-space"
        attr.id="{{id}}"
        [style.padding]="'0px'"
        [ngStyle]="{'display': 'inline-block'}"
        soho-alert
      >{{modelField.valueChanged | async | stateAsText:modelField.states}}</p>
    </div>
  } @else {
    <div
      [ngClass]="{'lm-is-radio-in-paragraph': lmParagraphLayoutInfo, 'lm-radio-field-options': true}"
      lm-field-options
      [hasContextMenu]="insertContextMenu"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      [disableFieldOptions]="disableFieldOptions"
      [fieldAutomationId]="fieldAutomationId"
      soho-tooltip
      [popover]="true"
      [title]="popoverTitle"
      [placement]="'right'"
      [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
      <div class="radio-button-group-wrapper"
        attr.aria-labelledby="{{id}}"
        role="radiogroup"
        [attr.tabindex]="isInAccessibilityMode && (readOnly$ | async) ? 0 : null">
        @for (item of values$ | async; track trackByValue(indx, item); let indx = $index) {
          <!-- the name="{{id}}_Option" is needed for the radio buttons to be correctly interpreted as separate fields.
          removing it caused https://jira.lawson.com/browse/LMCLIENT-32155 -->
          @if ((item && item.label != ' ') && !displayAsText) {
            <input
              type="radio"
              class="radio"
              attr.id="{{id}}_{{indx}}_Option"
              name="{{id}}_Option"
              attr.name="{{id}}_Option"
              [attr.bindId]="bindId"
              [attr.disabled]="(readOnly$ | async) ? true : null"
              value="{{item?.value}}"
              [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-radiobutton
              soho-alert
              soho-trackdirty
              (dirty)="onDirty($event)"
              (pristine)="onPristine($event)"
              (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"/>
            <label
              soho-label
              [forRadioButton]="true"
              attr.for="{{id}}_{{indx}}_Option"
              class="lm-radio-button-label"
              >
              {{item?.label}}
            </label>
            @if (!isHorizontal && indx != ((values$ | async).length - 1)) {
              <br/>
            }
          }
        }
      </div>
    </div>
  }
</div>

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
  }
</ng-template>
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}
<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
